import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api/admin';
const API_TIMEOUT = parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000;

const http = axios.create({
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

http.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    console.log("API call failed:", error);
    if ([502, 401].includes(error.response?.status)) {
      console.log("Session expired or unauthorized. Redirecting to login.", error);
      localStorage.clear();
      window.location.href = '/';
    } else {
      return Promise.resolve(error.response?.data);
    }
  }
);

/**
 * Attach global loader callbacks to the axios instance.
 * Called once from the LoadingProvider after mount.
 */
export const setupLoadingInterceptors = (showLoader, hideLoader) => {
  http.interceptors.request.use(
    (config) => {
      showLoader();
      return config;
    },
    (error) => {
      hideLoader();
      return Promise.reject(error);
    }
  );

  http.interceptors.response.use(
    (response) => {
      hideLoader();
      return response;
    },
    (error) => {
      hideLoader();
      return Promise.reject(error);
    }
  );
};

export default http;
